<div class="subheader-container">
  <div class="subheader-label">
    <h6 class="nmbcol">
      {{ "Sellers.Products.Notify_Buyers_Step" | translate }}
    </h6>
  </div>
</div>
<div class="p-3">
  <form [formGroup]="stepFourForm" *ngIf="stepFourForm">
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <p class="text-center my-3">
          {{ "Sellers.Products.Notify_Buyer_enter_fields" | translate }}
        </p>
      </div>
      <div class="row col-md-10 mt-3">
        <div class="col-md-6">
          <div class="mb-3">
            <mat-form-field appearance="outline" class="w-100" >
            <mat-label
              >{{ "Sellers.Products.Notify_Buyer_email" | translate }}
              <span class="text-danger">*</span></mat-label
            >
              <i data-feather="mail" class="fea icon-sm icons"></i>
              <input
                type="email"
                class="form-control "
                placeholder="{{
                  'Sellers.Products.Notify_Buyer_email' | translate
                }}"
                formControlName="email"
                [readonly]="!emailCheck.checked"
                [ngClass]="
                  formValidator.formErrors.email ? 'border-danger' : ''
                "
              matInput/>

              <mat-error
                class="text-danger fs-7"
                *ngIf="formValidator?.formErrors?.email"
              >
                {{ formValidator.formErrors.email }}
              </mat-error>
          </mat-form-field>
          </div>
          <div class="checkbox-container">
            <div class="form-check mb-0 mt-1 mb-3" >

              <input
                type="checkbox"
                formControlName="notifyEmail"
                class="form-check-input"
                id="Email-checkbox"
                (click)="handleValidation('email',$event.target.checked)"
                #emailCheck
              />
              <label for="Email-checkbox" class="from-label">
                {{ "Sellers.Products.Notify_email_option" | translate }}
              </label>
            </div>
            <p *ngIf="emailCheck.checked == true" class="text-info">
              {{ "Sellers.Products.isNotify_email_valid" | translate }}
            </p>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <mat-form-field appearance="outline" class="w-100" >
            <mat-label
              >{{ "Sellers.Products.Notify_Buyer_phone" | translate }}
              <span class="text-danger">*</span></mat-label
            >
              <i data-feather="phone" class="fea icon-sm icons"></i>
              <input
                type="text"
                class="form-control"
                placeholder="{{
                  'Sellers.Products.Notify_Buyer_phone' | translate
                }}"
                formControlName="phone"
                [readonly]="!phoneCheck.checked"
                [ngClass]="
                  formValidator.formErrors.phone ? 'border-danger' : ''
                "
              matInput/>
              <mat-error
                class="text-danger fs-7"
                *ngIf="formValidator?.formErrors?.phone"
              >
                {{ formValidator.formErrors.phone }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="checkbox-container">
            <div class="form-check mb-0" >
              <input
                type="checkbox"
                formControlName="notifyPhone"
                class="form-check-input"
                id="Phone-checkbox"
                (click)="handleValidation('phone',$event.target.checked)"
                #phoneCheck
              />
              <label for="Phone-checkbox" class="from-label">
                {{ "Sellers.Products.Notify_phone_option" | translate }}
              </label>
            </div>
            <p *ngIf="phoneCheck.checked == true" class="text-info">
              {{ "Sellers.Products.isNotify_phone_valid" | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
